// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WARNING: This section must be updated if _variables.ts is changed */
/* PERCENTAGE COLOURS */
.avatar {
  width: 42px;
  height: 42px;
  margin-left: 14px;
}

.unread-alerts {
  border-radius: 10px;
  font-weight: 500;
  color: white;
  background-color: #dc3545;
}

.cleared-alerts {
  border-radius: 10px;
  color: white;
  background-color: #078BCB;
}

.custom-dropdown-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 0;
}

.custom-dropdown-menu {
  border-radius: 8px;
  margin-top: 5px;
  padding-top: 0;
  padding-right: 10px;
  padding-left: 10px;
  width: 250px;
  border: 1px solid rgba(211, 211, 211, 0.75);
  box-shadow: 0 0.5rem 1rem rgba(35, 31, 32, 0.15) !important;
}

.greeting-message {
  padding: 10px 10px 0 10px;
  font-size: 14px;
  font-weight: 700;
}

.comment-icon {
  position: relative;
  width: 2rem;
  height: 2rem;
  background-color: transparent;
  border-radius: 0.5rem;
  padding: 0.25rem;
  margin-left: 0.5rem;
  cursor: pointer;
}
.comment-icon .badge {
  position: absolute;
  top: 0;
  right: 0;
  background-color: #078BCB;
  color: white;
  border-radius: 50%;
  padding: 2px 5px;
  font-size: 10px;
}
.comment-icon:hover {
  background-color: rgba(211, 211, 211, 0.4);
}
.comment-icon:hover svg {
  color: #414448;
}
.comment-icon svg {
  color: gray;
}
.comment-icon .unread-alerts {
  border-radius: 10px;
  font-weight: 500;
  color: white;
  background-color: #dc3545;
}
.comment-icon .cleared-alerts {
  border-radius: 10px;
  color: white;
  background-color: #078BCB;
}

.menu-badge {
  border-radius: 50%;
  padding: 2px 5px;
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/white-labelling/default/_variables.scss","webpack://./src/app/core/components/header/components/dashboard-header-menu/dashboard-header-menu.component.scss"],"names":[],"mappings":"AAiDA,sEAAA;AAYA,uBAAA;AC3DA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;AACD;;AAEA;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AACD;;AAEA;EACC,mBAAA;EACA,YAAA;EACA,yBDhBS;ACiBV;;AAEA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AACD;;AAEA;EACC,kBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,2CAAA;EACA,2DAAA;AACD;;AAEA;EACC,yBAAA;EACA,eAAA;EACA,gBAAA;AACD;;AAEA;EACC,kBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACD;AACC;EACC,kBAAA;EACA,MAAA;EACA,QAAA;EACA,yBDzDQ;EC0DR,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;AACF;AAEC;EACC,0CAAA;AAAF;AAEE;EACC,cDlDY;ACkDf;AAIC;EACC,WAAA;AAFF;AAKC;EACC,mBAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;AAHF;AAMC;EACC,mBAAA;EACA,YAAA;EACA,yBDtFQ;ACkFV;;AAQA;EACC,kBAAA;EACA,gBAAA;EACA,eAAA;AALD","sourcesContent":["// Core theme colors\n$primary0: #0EABF7;\n$primary: #078BCB;\n$primary2: #067ab2;\n$primary3: #05699a;\n$selectedBackground: #ebf5ff;\n\n// Colour variables\n$black: #000000;\n$border-colour: #dee2e6;\n$card-border: #dfdfdf;\n$cardBorderGrey: #d9dee8;\n$disabled: #caced5;\n$disabledButtonColor: #7bb3d0;\n$disabled-background: #ececec;\n$form-error: #f84646;\n$highlight: #f5f5f5;\n$hoverHighlight: rgba(35, 31, 32, 0.31);\n$inactive: rgba(255, 0, 0, 0.1);\n$inactiveHighlight: rgba(255, 0, 0, 0.2);\n$kaliber-dark: #414448;\n$link: #2185d0;\n$placeholder: #aab2c0;\n$selectedButton: #002865;\n$subtitle: #a0a2a4;\n$white: #ffffff;\n$cardBorderGrey: #d9dee8;\n\n// Bootstrap Colours\n$secondary: #222222;\n$dark: #7a7a7a;\n$background-light: #efefef;\n$print-page-size: auto;\n\n$danger: #d9534f;\n$muted: #85959f;\n$text-muted: #85959f;\n$success: #61f2b6;\n$warning: #f0ad4e;\n$info: #5bc0de;\n$light: #f8f9fa;\n$light-gray: #d3d3d3;\n$background-dark: #414448;\n$disabled-background: rgba(221, 221, 221, 0.3) !default;\n\n// Common Styles\n$border: 1px solid $border-colour;\n$appComsHeight: 60px;\n\n/* WARNING: This section must be updated if _variables.ts is changed */\n$target: #fcb800;\n$declined: #d11f4b;\n$active: #f77f21;\n$quoteReady: #d299c4;\n$quoteApproved: #7c4795;\n$submitted: #662066;\n$won: #3e9937;\n$lost: #00245e;\n$live: #00b0f0;\n$completed: #a9d18e;\n\n/* PERCENTAGE COLOURS */\n$percentage-green: #15b422;\n$percentage-light-green: #a3d000;\n$percentage-yellow: #fcb000;\n$percentage-red: #ff0000;\n\n// DO NOT USE IF YOU SEE THESE BEING USED. PLEASE REMOVE\n$exportTableHeight: 530px;\n$footerHeight: 60px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n$headerHeight: 42px;\n$inputPercentWidth: 91px;\n$inputDiscountWidth: 126px;\n$exportTableHeight: 530px;\n$incExcTableHeight: 300px;\n$sidebarMenuWidth: 120px;\n$sideNavWidth: 67px;\n$height650px: 650px;\n$headerNavHeight: 60px;\n\n// Image References\n$loginLogo: './assets';\n","@import 'variables';\n\n.avatar {\n\twidth: 42px;\n\theight: 42px;\n\tmargin-left: 14px;\n}\n\n.unread-alerts {\n\tborder-radius: 10px;\n\tfont-weight: 500;\n\tcolor: white;\n\tbackground-color: #dc3545;\n}\n\n.cleared-alerts {\n\tborder-radius: 10px;\n\tcolor: white;\n\tbackground-color: $primary;\n}\n\n.custom-dropdown-item {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tborder: 0;\n}\n\n.custom-dropdown-menu {\n\tborder-radius: 8px;\n\tmargin-top: 5px;\n\tpadding-top: 0;\n\tpadding-right: 10px;\n\tpadding-left: 10px;\n\twidth: 250px;\n\tborder: 1px solid rgba(211, 211, 211, 0.75);\n\tbox-shadow: 0 0.5rem 1rem rgba(35, 31, 32, 0.15) !important;\n}\n\n.greeting-message {\n\tpadding: 10px 10px 0 10px;\n\tfont-size: 14px;\n\tfont-weight: 700;\n}\n\n.comment-icon {\n\tposition: relative;\n\twidth: 2rem;\n\theight: 2rem;\n\tbackground-color: transparent;\n\tborder-radius: 0.5rem;\n\tpadding: 0.25rem;\n\tmargin-left: 0.5rem;\n\tcursor: pointer;\n\n\t.badge {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tright: 0;\n\t\tbackground-color: $primary;\n\t\tcolor: white;\n\t\tborder-radius: 50%;\n\t\tpadding: 2px 5px;\n\t\tfont-size: 10px;\n\t}\n\n\t&:hover {\n\t\tbackground-color: rgba(lightgray, 0.4);\n\n\t\tsvg {\n\t\t\tcolor: $kaliber-dark;\n\t\t}\n\t}\n\n\tsvg {\n\t\tcolor: gray;\n\t}\n\n\t.unread-alerts {\n\t\tborder-radius: 10px;\n\t\tfont-weight: 500;\n\t\tcolor: white;\n\t\tbackground-color: #dc3545;\n\t}\n\n\t.cleared-alerts {\n\t\tborder-radius: 10px;\n\t\tcolor: white;\n\t\tbackground-color: $primary;\n\t}\n}\n\n.menu-badge {\n\tborder-radius: 50%;\n\tpadding: 2px 5px;\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
